import ThemeProvider, {
  useTheme,
  useThemeFlag,
  ThemeContext,
  ERASMUSU_THEME,
  SPOTAHOME_THEME,
  LANDLORD_THEME
} from './ThemeProvider';

export default ThemeProvider;
export {
  useTheme,
  useThemeFlag,
  ThemeContext,
  ERASMUSU_THEME,
  SPOTAHOME_THEME,
  LANDLORD_THEME
};
